var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrafficChannels(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 4.16406C16.5 5.54477 13.1421 6.66406 9 6.66406C4.85786 6.66406 1.5 5.54477 1.5 4.16406M16.5 4.16406C16.5 2.78335 13.1421 1.66406 9 1.66406C4.85786 1.66406 1.5 2.78335 1.5 4.16406M16.5 4.16406V15.8307C16.5 17.2141 13.1667 18.3307 9 18.3307C4.83333 18.3307 1.5 17.2141 1.5 15.8307V4.16406M16.5 9.9974C16.5 11.3807 13.1667 12.4974 9 12.4974C4.83333 12.4974 1.5 11.3807 1.5 9.9974",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrafficChannels);
export default __webpack_public_path__ + "static/media/traffic-channels.6905312a8acd0c6b08f562401e61276b.svg";
export { ForwardRef as ReactComponent };